import Icon from '../../components/Icon.vue';
Icon.register({
  'brands/ioxhost': {
    width: 640,
    height: 512,
    paths: [{
      d: 'M616 160c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24h-52.7c3.1 15.5 4.7 31.6 4.7 48 0 137-111 248-248 248-102.9 0-191.2-62.7-228.7-152h-67.3c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24h52.7c-3.1-15.5-4.7-31.6-4.7-48 0-137 111-248 248-248 102.9 0 191.2 62.7 228.7 152h67.3zM520 256c0-16.6-2-32.6-5.8-48h-298.2c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24h279.5c-33.9-62-99.8-104-175.5-104-110.5 0-200 89.5-200 200 0 16.6 2 32.6 5.8 48h298.2c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24h-279.5c33.9 62 99.8 104 175.5 104 110.5 0 200-89.5 200-200zM216 232h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24h-208c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z'
    }]
  }
});